import React from "react";
import styled from "styled-components";
import { color, font } from "../../theme/tokens";

const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 10px;
  padding-bottom: 32px;
  margin-bottom: 40px;
  border-bottom: 1px solid ${color.rule};

  @media screen and (max-width: 600px) {
    gap: 6px 8px;
    padding-bottom: 24px;
    margin-bottom: 28px;
  }
`;

const Chip = styled.button`
  font-family: ${font.body};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 999px;
  padding: 9px 15px;
  /* Comfortable touch target on a phone. */
  min-height: 40px;
  white-space: nowrap;
  transition: background 160ms ease, color 160ms ease, border-color 160ms ease;

  color: ${({ $active }) => ($active ? color.white : color.ink)};
  background: ${({ $active }) => ($active ? color.green : 'transparent')};
  border: 1px solid ${({ $active }) => ($active ? color.green : color.rule)};

  &:hover {
    border-color: ${({ $active }) => ($active ? color.green : color.inkMuted)};
  }

  span {
    opacity: 0.6;
    margin-left: 6px;
    font-weight: 500;
  }

  @media screen and (max-width: 600px) {
    font-size: 10.5px;
    letter-spacing: 0.03em;
    padding: 8px 11px;
    min-height: 36px;
  }
`;

/**
 * Sector filter for the portfolio grid. `sectors` comes from sectorsFrom(),
 * so only groups that actually have companies are offered.
 */
export default function SectorFilter({ sectors, active, onChange, total }) {
  return (
    <Bar role="group" aria-label="Filter portfolio by sector">
      <Chip
        type="button"
        $active={active === null}
        aria-pressed={active === null}
        onClick={() => onChange(null)}
      >
        All <span>{total}</span>
      </Chip>
      {sectors.map(({ label, count }) => (
        <Chip
          key={label}
          type="button"
          $active={active === label}
          aria-pressed={active === label}
          onClick={() => onChange(active === label ? null : label)}
        >
          {label} <span>{count}</span>
        </Chip>
      ))}
    </Bar>
  );
}
